import i18next, { t } from "i18next";

export function getPieChartSessionStatusOptions(
  Labels: string[],
  data: number[]
) {
  const done = "#34D399";
  const canceled = "#F87171";
  const scheduled = "#9CA3AF";
  const legendposition: "bottom" = "bottom";
  const dir = "ltr" === i18next.dir();
  return {
    options: {
      plotOptions: {
        pie: {
          donut: {
            labels: {
              show: true,
              name: {
                fontFamily: "Readex Pro",
              },
              total: {
                showAlways: true,
                fontFamily: "Readex Pro",
              },
            },
          },
        },
      },
      dataLabels: {
        enabled: false,
      },
      legend: {
        show: true,
        position: legendposition,
        fontFamily: "Readex Pro",
        markers: {
          width: 15,
          height: 15,
          offsetX: dir ? -3 : 3,
        },
      },
      tooltip: {
        style: {
          fontFamily: "Readex Pro",
        },
      },
      colors: [scheduled, done, canceled],
      labels: Labels,
    },
    series: data,
  };
}
export function getRadialBarPagesProgressOptions(
  Labels: string[],
  data: number[]
) {
  const left = "#9CA3AF";
  const Remimneg = "#2491FF";
  const legendposition: "bottom" = "bottom";
  const dir = "ltr" === i18next.dir();
  return {
    options: {
      plotOptions: {
        pie: {
          donut: {
            labels: {
              show: true,
              name: {
                fontFamily: "Readex Pro",
              },
              total: {
                showAlways: true,
                fontFamily: "Readex Pro",
                formatter: (val: any) => {
                  return val + "/250";
                },
              },
            },
          },
        },
      },
      dataLabels: {
        enabled: false,
      },
      legend: {
        show: true,
        position: legendposition,
        fontFamily: "Readex Pro",
        markers: {
          width: 15,
          height: 15,
          offsetX: dir ? -3 : 3,
        },
      },
      tooltip: {
        style: {
          fontFamily: "Readex Pro",
        },
      },
      colors: [left, Remimneg],
      labels: Labels,
    },
    series: data,
  };
}
export function getLineChartOptions(
  XTitle: string,
  series?: any,
  categories?: any
) {
  const dir = "ltr" === i18next.dir();
  return {
    options: {
      dataLabels: {
        enabled: false,
      },
      colors: ["#EF4444"],

      stroke: {
        width: [4],
      },
      plotOptions: {
        bar: {
          columnWidth: "20%",
        },
      },

      yaxis: {
        align: "center",
        labels: {
          style: {
            fontFamily: "Readex Pro",
          },
        },
        title: {
          text: XTitle,
          style: {
            fontFamily: "Readex Pro",
          },
        },
      },
      xaxis: {
        categories: categories,
      },
      markers: {
        size: 5,
      },
      tooltip: {
        shared: false,
        intersect: true,
        x: {
          show: false,
        },
      },
      legend: {
        horizontalAlign: dir ? "left" : "right",
        fontFamily: "Readex Pro",
      },
    },
    series: [
      {
        name: XTitle,
        data: !!series ? series : [],
      },
    ],
  };
}
export function getBarChartOptions(series: any, categories: any[]) {
  const dir = "ltr" === i18next.dir();
  const unpassed = "#FCCAA5";
  const passed = "#5CADFF";
  return {
    options: {
      chart: {
        type: "bar",
        height: 350,
        stacked: true,
        toolbar: {
          show: true,
        },
        zoom: {
          enabled: true,
        },
      },
      tooltip: {
        style: {
          fontFamily: "Readex Pro",
        },
      },
      colors: [passed, unpassed],
      responsive: [
        {
          breakpoint: 480,
          options: {
            legend: {
              position: "bottom",
              offsetX: -10,
              offsetY: 0,
            },
          },
        },
      ],
      plotOptions: {
        bar: {
          horizontal: false,
        },
      },
      xaxis: {
        categories,
      },
      legend: {
        position: dir ? "left" : "right",
        offsetY: 40,
        fontFamily: "Readex Pro",
        markers: {
          width: 15,
          height: 15,
          offsetX: dir ? -3 : 3,
        },
      },
      fill: {
        opacity: 1,
      },
    },
    series: series,
  };
}
export function getBarChartOneOption(series: any, categories: any[]) {
  const dir = "ltr" === i18next.dir();
  const passed = "#EF4444";
  return {
    options: {
      chart: {
        type: "bar",
        height: 350,
        stacked: true,
        toolbar: {
          show: true,
        },
        zoom: {
          enabled: true,
        },
      },
      tooltip: {
        style: {
          fontFamily: "Readex Pro",
        },
      },
      colors: [passed],
      responsive: [
        {
          breakpoint: 480,
          options: {
            legend: {
              position: "bottom",
              offsetX: -10,
              offsetY: 0,
            },
          },
        },
      ],
      plotOptions: {
        bar: {
          horizontal: false,
        },
      },
      xaxis: {
        categories,
      },
      legend: {
        position: dir ? "left" : "right",
        offsetY: 40,
        fontFamily: "Readex Pro",
        markers: {
          width: 15,
          height: 15,
          offsetX: dir ? -3 : 3,
        },
      },
      fill: {
        opacity: 1,
      },
    },
    series: series,
  };
}
